import React from 'react'
import Temp from './Temp'

const App = () => {
  return (
    <div>
      <Temp/>
    </div>
  )
}

export default App
